module.exports = __webpack_public_path__ + "files/ed976d766228b3e1f560005baf45f992.svg";